
import { NONE } from '../constants/types';

const getterSetter = function(ts, key, value=NONE) { 
                       if (value === NONE) return ts._params[key];
                       ts._params[key] = value;
                       return ts;
                     }

export default getterSetter;                    